// ── Preview-only demo data for shipping-label previews ─────────────────────────
// Label templates are built for Thymeleaf (the server fills `th:text="${order.X}"`, `th:each`,
// `th:src` etc.), so in the browser those bindings render empty. For ON-SCREEN PREVIEWS ONLY we
// swap the bindings for realistic demo values so the preview looks like a real printed label.
// This is NEVER applied to the template we download or upload — that keeps the raw Thymeleaf.
// Shared by the Customize tab (LabelDIY) and the Upload & View tab (LabelConfig).

const PREVIEW_ORDER = {
  awbNumber: '31049539170746', orderId: '634010062025', shippingLabelId: 'KOLK00669',
  paymentMode: 'PREPAID', courierName: 'Delhivery Surface',
  dropName: 'Rahul Sharma', dropAddress: '12, MG Road, Near City Mall, Indiranagar',
  dropCity: 'Bengaluru', dropState: 'Karnataka', dropPincode: '560038', dropContactNumber: '98765 43210',
  awbRegisteredDate: '23 Jul 2026', sortCode: 'BLR/KA',
  invoiceValue: '1,299', shippingMode: 'Surface', serviceType: 'Forward',
  deadWeight: '0.50', length: '20', breadth: '15', height: '10',
  pickupDetails: 'Prozo Warehouse, Kolkata', pickupGstin: '29ABCDE1234F1Z5',
  returnName: 'Prozo Returns', returnAddress: 'Plot 5, Sector 5, Bidhannagar, Kolkata',
  returnPincode: '700091', returnPhone: '75498 30612',
  channelOrderName: '#SH-1042',
};

const PREVIEW_ITEMS = [
  { itemName: 'Cotton T-Shirt (Blue, L)', skuId: 'TSHIRT-BL-L', quantity: '2' },
  { itemName: 'Slim-Fit Denim Jeans (32)', skuId: 'JEANS-SLM-32', quantity: '1' },
  { itemName: 'Running Shoes (UK 9)', skuId: 'SHOE-RUN-UK9', quantity: '1' },
  { itemName: 'Ankle Socks (Pack of 3)', skuId: 'SOCK-ANK-P3', quantity: '3' },
];
const PREVIEW_ITEM = PREVIEW_ITEMS[0];

const PREVIEW_BARCODE = 'data:image/svg+xml;utf8,' + encodeURIComponent(
  "<svg xmlns='http://www.w3.org/2000/svg' width='240' height='56'><rect width='240' height='56' fill='white'/>" +
  Array.from({ length: 47 }).map((_, i) => `<rect x='${i * 5}' y='2' width='${(i % 3) + 1}' height='44' fill='black'/>`).join('') +
  "</svg>");
const PREVIEW_LOGO = 'data:image/svg+xml;utf8,' + encodeURIComponent(
  "<svg xmlns='http://www.w3.org/2000/svg' width='120' height='48'><rect width='120' height='48' fill='#eef1f5'/><text x='60' y='30' font-size='14' text-anchor='middle' fill='#637381' font-family='sans-serif'>LOGO</text></svg>");

// Replace Thymeleaf bindings in a label-template HTML string with the demo values above.
export const fillPreviewData = (html) => {
  if (!html) return html;
  let out = html;
  // Images (barcode / order-id barcode / logo)
  out = out.replace(/th:src="\$\{order\.(\w+)\}"/g, (m, field) => `src="${field === 'logo' ? PREVIEW_LOGO : PREVIEW_BARCODE}"`);
  // Item table: expand the single th:each row into 4 realistic dummy rows
  out = out.replace(/<tr\b[^>]*\sth:each="[^"]*"[^>]*>([\s\S]*?)<\/tr>/, (m, inner) =>
    PREVIEW_ITEMS.map((item) => {
      const row = inner
        .replace(/\s*th:if="\$\{[^}]*\}"/g, '')
        .replace(/<span\b([^>]*)\sth:text="\$\{item\.(\w+)\}"([^>]*)>\s*<\/span>/g,
          (mm, pre, field, post) => `<span${pre}${post}>${item[field] != null ? String(item[field]) : ''}</span>`);
      return `<tr>${row}</tr>`;
    }).join(''),
  );
  // Drop any remaining th:each (none expected)
  out = out.replace(/\s*th:each="[^"]*"/g, '');
  // Strip th:if so conditionally-shown elements always appear in the preview
  out = out.replace(/\s*th:if="\$\{[^}]*\}"/g, '');
  // Fill th:text spans with the demo value
  out = out.replace(/<span\b([^>]*)\sth:text="\$\{(order|item)\.(\w+)\}"([^>]*)>\s*<\/span>/g,
    (m, pre, scope, field, post) => {
      const src = scope === 'item' ? PREVIEW_ITEM : PREVIEW_ORDER;
      const val = src[field] != null ? String(src[field]) : '';
      return `<span${pre}${post}>${val}</span>`;
    });
  return out;
};

export default fillPreviewData;
